<template>
    <bita-modal
        id="portfolio-phase"
        :is-loading="isLoadingModal"
        :modal-lg="true"
        title=" فازهای اجرایی"
        @close="reset()"
    >
        <div slot="body">
            <bita-form ref="form">
                <div slot="body">
                    <div
                        class="row"
                        v-for="(phase, index) in phases"
                        :key="index"
                    >
                        <div class="col-lg-9">
                            <div class="form-group">
                                <label>
                                    عنوان
                                </label>
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="phase.title"
                                />
                            </div>
                        </div>
                        <div class="col-3 mt-4">
                            <div
                                class="btn btn-danger ml-1"
                                @click="removePhase(phase, index)"
                            >
                                حذف
                            </div>
                            <div
                                class="btn btn-success"
                                @click="addPhase()"
                            >
                                افزودن
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    توضیحات
                                </label>
                                <textarea
                                    class="form-control"
                                    type="text"
                                    rows="5"
                                    v-model="phase.description"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="text-left">
                        <div
                            v-if="!phases.length > 0"
                            class="btn btn-success"
                            @click="addPhase()"
                        >
                            افزودن
                        </div>
                    </div>
                </div>
            </bita-form>
        </div>
        <div slot="footer">
            <bita-bootbutton
                title="بروز رسانی"
                type="primary mb-3"
                icon="fas fa-save"
                btn-width="150px"
                @click.native="update"
                :disabled="isLoadingModal"
            />
        </div>
    </bita-modal>
</template>
<script>
import { portfolioApi } from "@/api/apiManagement";
export default {
    data() {
        return {
            colWidth: "col-lg-6",
            formData: {},
            phases: [],
            isLoadingModal: false,
        }
    },
    methods: {
        setInitialData(_data) {
            this.isLoadingModal = true;
            this.formData = _data;
            this.phases = this.formData.phase && this.formData.phase.length > 0 ? 
                this.serializePhase(this.formData.phase) : 
                [{ description: null }];
            this.isLoadingModal = false;
        },
        update() {
            this.$refs.form.validate()
                .then( (res) => {
                    if ( res ) {
                        this.isLoadingModal = true;
                        let data = { phase: this.phases };
                        portfolioApi.update(this.formData.id, data)
                            .then( (res) => {
                                this.$izitoast("success", "موفق!", res.data.message);
                                this.$toggleModal("#portfolio-phase");
                                this.$emit("load-data");
                            })
                            .finally( () => this.isLoadingModal = false );
                    }
                })
        },
        serializePhase(_phase) {
            let data = [];
            _phase.forEach((element,index) => {
                data[index] = {
                    description: element.description,
                    title: element.title
                }
            });
            return data;
        },
        removePhase(_phase, _index) {
            this.$delete(this.phases, _index);
        },
        addPhase() {
            this.phases.push({ description: "" });
        },
        reset() {
            this.formData = {};
            this.phases = [];
            this.$refs.form.reset();
        },
    }
}
</script>